var map = {
	"./arrow-circle.svg": 224,
	"./arrow.svg": 979,
	"./btn-arrow.svg": 580,
	"./cherry-logo.svg": 109,
	"./clock.svg": 642,
	"./email.svg": 840,
	"./nav-arrow.svg": 531,
	"./opening-quote.svg": 515,
	"./phone.svg": 596,
	"./play.svg": 590,
	"./shopping-cart.svg": 407,
	"./star.svg": 416,
	"./times.svg": 826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 312;